import { Caption } from "@components/Typography";
import { PropsWithChildren } from "react";
import { useStyles } from "./styles";

export const TimeFrame = ({ children }: PropsWithChildren) => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      <Caption style={styles.text}>{children}</Caption>
    </div>
  );
};
